import React, { useState, useEffect, useRef, useCallback } from 'react';
import AccountList from '../components/Dashboard/AccountList';
import ScannerLibrary, { ParentPicker } from '../components/Dashboard/ScannerLibrary';
import ScannerFolderList from '../components/Dashboard/ScannerFolderList';
import AssetList from '../components/Dashboard/AssetList';
import InstrumentTypeFilter from '../components/Dashboard/InstrumentTypeFilter';
import TradingViewWidget from '../components/Dashboard/TradingViewWidget';
import SyntheticAssetsManager from '../components/Dashboard/SyntheticAssetsManager';
import AuthErrorModal from '../components/Dashboard/AuthErrorModal';
import {
  fetchAccounts,
  fetchAssets,
  fetchData,
  fetchStatistics,
  changeActiveSource,
  toggleSide,
  fetchDeepAssets,
  toggleActive,
  cleanupTosActiveState,
  toggleOffensive,
  toggleFestival,
  switchMaster,
  fetchMasterStatus,
  fetchContfutOnlyStatus,
  updateAssetConfig,
  fetchUserProfile,
  toggleSpinDown,
  toggleTradingInstrument,
  abortPostboxInstrument,
  getTradingInstrument,
  toggleTradingAuto,
  getTradingAuto,
  cycleScannerWaveFilter,
  getScannerWaveFilter,
  toggleInstrumentSync,
  getInstrumentSync,
  setTimeframeSide,
  setJ2F,
  getAuthToken,
  setJoeRider,
  setTimeframeMetaAutoresolve,
  syncVirtualAccountAssets,
  setSyntheticTROS,
  setAuthErrorHandler,
  setCounterState,
  setSTS,
  setPatch,
  setTOSPatch,
  setTacticalStart,
  setUpdown,
  getVirtualAccountInstruments,
  setFade,
  setActiveTimeframe,
  setLeverage,
  setTOSQuantity,
  getVirtualAccountSyncSettings,
  addInstrumentToFolder
} from '../services/api';
import { assetMatchesInstrumentType, folderAssetOf, folderStaleParents, pickFolderAssets, refreshOpenFolder, reversePatchCrypto, reversePatchSec, timeframes, truncateText } from '../utils/helpers';
import ConfigPanel, { postboxAbortSummary } from '../components/Dashboard/ConfigPanel';
import ToggleSwitch from '../components/common/ToggleSwitch';
import SignalHistory from '../components/Dashboard/SignalHistory';
import SyntheticTROSForm from '../components/Dashboard/SyntheticTROSForm';
import STSTimelineList from '../components/Dashboard/STSTimelineList';
import ConfigPatch from '../components/Dashboard/ConfigPatch';
import TOSPanel, { TOS_PANEL_SOLO_GRID_LOCATION } from '../components/Dashboard/TOSPanel';
import { filterAssetsForViewMode, isEnabledOnVirtual, matchesSectypes, sectypeOptions, tradingFlagFor } from './newHomePageAssetVisibility';
import MultiSelect, { plain } from '../components/common/MultiSelect';
import { isInstrumentTypeFilterEnabled } from '../config/featureFlags';
import { buildSelectionStateFromAccount, reduceAccountSelection } from './newHomePageAccountSelection';
import SoloStatisticsRow from './SoloStatisticsRow';
import NotificationFeedInline from '../components/Notifications/NotificationFeedInline';
import FolderTabs from '../components/common/FolderTabs';
import InstrumentPlacement from '../components/Dashboard/InstrumentPlacement';
import {
  SOLO_STS_TIMELINE_INLINE_CLASS,
  SOLO_STS_TIMELINE_XL_GRID_LOCATION,
  SOLO_FOCUS_TOS_PANEL_GRID_LOCATION,
} from './soloLayout';



// `focus` = { mode: 'solo' | 'scanner', asset } embeds one instrument's panel
// (Dashboard Favorites): no account list, toggles or asset lists, no own feed.
function NewHomePage({ focus = null }) {
  const timeframes_ws = useRef();

  const [timeframesInfo, setTimeframesInfo] = useState(null);
  const soloSourcesRef = useRef({});
  const soloPatchRef = useRef({});
  const [timeframesWsConnected, setTimeframesWsConnected] = useState(false);

  const [accounts, setAccounts] = useState([]);
  const [assets, setAssets] = useState([]);
  const [statistics, setStatistics] = useState([]);
  const [tvSymbol, setTVSymbol] = useState(null);
  // 'solo' (TOS) | 'counter'; focus mode pins it to its panel.
  const [viewMode, setViewMode] = useState(focus?.mode === 'scanner' ? 'counter' : 'solo');
  const [tradingAccount, setTradingAccount] = useState(null);
  const [counterAccount, setCounterAccount] = useState(null);
  const selectedAccount = viewMode === 'counter' ? counterAccount : tradingAccount;
  // TOS sectype filter, like Favorites'; another account starts unfiltered.
  const [tosSectypes, setTosSectypes] = useState([]);
  const [tosSectypeOpen, setTosSectypeOpen] = useState(false);
  useEffect(() => { setTosSectypes([]); }, [selectedAccount]);
  const [selectedStrategy, setSelectedStrategy] = useState('tos');
  const [selectedAsset, setSelectedAsset] = useState(null);
  // TOS Solo: Accounts / Live Feed tabs under the Dashboard title; the choice survives instrument switches.
  const [soloTab, setSoloTab] = useState('accounts');

  const [userProfile, setUserProfile] = useState(null);

  const [isFetching, setIsFetching] = useState(false);
  const [skipFetchFlag, setSkipFetchFlag] = useState(false);
  const [masterSwitch, setMasterSwitch] = useState(null);
  const [tradingInstrument, setTradingInstrument] = useState(false);
  const [tradingAuto, setTradingAuto] = useState(false); // false = SEMI
  const [scannerWaveFilter, setScannerWaveFilter] = useState('first');
  const [tradingWaveFilter, setTradingWaveFilter] = useState('off');
  const [instrumentSync, setInstrumentSync] = useState(false);
  const [contfutOnly, setContfutOnly] = useState(null);
  const [instrumentType, setInstrumentType] = useState('futures');
  const [assetTradingFlags, setAssetTradingFlags] = useState({});
  // COUNTER: pick a folder, then an instrument inside it. The library — where
  // folders and their contents are edited — is a separate screen behind its own button.
  const [counterFolder, setCounterFolder] = useState(null);
  const [showLibrary, setShowLibrary] = useState(false);
  const [libraryRevision, setLibraryRevision] = useState(0);
  const loadedCounterFolder = useRef(null);
  const [staleParents, setStaleParents] = useState([]);
  const [counterRefreshing, setCounterRefreshing] = useState(false);
  const [counterRefreshFailed, setCounterRefreshFailed] = useState(false);
  const assetsLoadSeq = useRef(0);
  const [wsMounted, setwsMounted] = useState(false);

  const [seniorTimeframe, setSeniorTimeframe] = useState(null);

  const [isVirtualAccount, setIsVirtualAccount] = useState(false);
  const [virtualAccountId, setVirtualAccountId] = useState(null);
  const [sourceAccount, setSourceAccount] = useState(null);
  const [linkedAccounts, setLinkedAccounts] = useState([]);
  const [syncStatus, setSyncStatus] = useState({ inProgress: false, lastSynced: null });
  const [showAuthErrorModal, setShowAuthErrorModal] = useState(false);
  const [virtualAccountSyncSettings, setVirtualAccountSyncSettings] = useState(null);

  // Добавить новое состояние для enabled instruments
  const [enabledInstruments, setEnabledInstruments] = useState([]);
  const [enabledInstrumentsFor, setEnabledInstrumentsFor] = useState(null);   // virtual account they belong to
  const [enabledInstrumentsFailed, setEnabledInstrumentsFailed] = useState(false);
  const [assetCompatibility, setAssetCompatibility] = useState({ incompatible: [] });

  // const [lampOn, setLampOn] = useState(false);
  // const [activeFlags, setActiveFlags] = useState([]);

  useEffect(() => {
    const loadAccounts = async () => {
      const fetchedAccounts = await fetchAccounts();
      setAccounts(fetchedAccounts);
    };
    const loadUserProfile = async () => {
      const profile = await fetchUserProfile();
      setUserProfile(profile);
    };
    setAuthErrorHandler(() => {
      setShowAuthErrorModal(true);
    });
    loadAccounts();
    loadUserProfile();

    return () => {
      closeTimeframesSocket();
      setAuthErrorHandler(null);
    };
  }, []);

  // Focus mode: the asset comes in whole, its account rides on it (as in COUNTER).
  const focusAsset = focus?.asset || null;
  useEffect(() => {
    if (!focusAsset) return;
    const account = accounts.find((a) => a.account === focusAsset.account && a.broker === focusAsset.broker)
      || { id: `focus-${focusAsset.broker}-${focusAsset.account}`, broker: focusAsset.broker, account: focusAsset.account };
    if (viewMode === 'counter') setCounterAccount(account);
    else setTradingAccount(account);
  }, [focusAsset, viewMode, accounts]);

  useEffect(
    () => {
      // timeframes socket feeds TOSPanel in both 'solo' and 'counter' tabs
      const needsTimeframesSocket = viewMode === 'solo' || viewMode === 'counter';
      if (needsTimeframesSocket && timeframesWsConnected) {
        closeTimeframesSocket();
        setTimeframesInfo(null);
        if (selectedAsset !== null) {
          connectTimeframesWs();
        }
      }
      if (needsTimeframesSocket && !timeframesWsConnected && selectedAsset !== null) {
        connectTimeframesWs();
      }
      if (needsTimeframesSocket && selectedAsset === null) {
        setTimeframesInfo(null);
      }
    }, [selectedAsset, viewMode]
  )

  useEffect(() => {
    if (!selectedAsset) {
      setTradingInstrument(false);
      setTradingAuto(false);
      return;
    }
    let cancelled = false;
    (async () => {
      const account = selectedAsset.broker === 'okx' ? userProfile?.name : selectedAsset.account;
      const status = await getTradingInstrument(
        selectedAsset.symbol,
        selectedAsset.broker,
        account,
        selectedAsset.sectype,
      );
      const filter = await getScannerWaveFilter(
        selectedAsset.symbol,
        selectedAsset.broker,
        account,
        selectedAsset.sectype,
      );
      const auto = await getTradingAuto(
        selectedAsset.symbol,
        selectedAsset.broker,
        account,
        selectedAsset.sectype,
      );
      if (!cancelled) {
        setTradingInstrument(!!status);
        setTradingAuto(!!auto);
        setScannerWaveFilter(filter?.mode || 'first');
        setTradingWaveFilter(filter?.tradingMode || 'off');
      }
    })();
    return () => { cancelled = true; };
  }, [selectedAsset, userProfile]);

  const handleToggleTradingInstrument = async () => {
    if (!selectedAsset) return;
    const account = selectedAsset.broker === 'okx' ? userProfile?.name : selectedAsset.account;
    const prev = tradingInstrument;
    setTradingInstrument(!prev); // optimistic
    const result = await toggleTradingInstrument(
      selectedAsset.symbol,
      selectedAsset.broker,
      account,
      selectedAsset.sectype,
    );
    if (result === null) {
      setTradingInstrument(prev); // revert on failure
    } else {
      setTradingInstrument(!!result);
      setAssetTradingFlags((m) => ({ ...m, [assetTradingKey(selectedAsset)]: !!result }));
    }
  };

  const handleToggleTradingAuto = async () => {
    if (!selectedAsset) return;
    const account = selectedAsset.broker === 'okx' ? userProfile?.name : selectedAsset.account;
    const prev = tradingAuto;
    setTradingAuto(!prev); // optimistic
    const result = await toggleTradingAuto(
      selectedAsset.symbol,
      selectedAsset.broker,
      account,
      selectedAsset.sectype,
    );
    setTradingAuto(result === null ? prev : !!result);
  };

  const handleAbortPostbox = async () => {
    if (!selectedAsset) return;
    const account = selectedAsset.broker === 'okx' ? userProfile?.name : selectedAsset.account;
    const result = await abortPostboxInstrument(
      selectedAsset.symbol,
      selectedAsset.broker,
      account,
      selectedAsset.sectype,
    );
    window.alert(postboxAbortSummary(selectedAsset.symbol, result));
  };

  const handleCycleScannerWaveFilter = async () => {
    if (!selectedAsset) return;
    const account = selectedAsset.broker === 'okx' ? userProfile?.name : selectedAsset.account;
    const result = await cycleScannerWaveFilter(
      selectedAsset.symbol,
      selectedAsset.broker,
      account,
      selectedAsset.sectype,
    );
    if (!result) return;
    // One shared key: refresh both readings.
    setScannerWaveFilter(result.mode);
    setTradingWaveFilter(result.tradingMode);
  };

  useEffect(() => {
    if (!selectedAsset) {
      setInstrumentSync(false);
      return;
    }
    let cancelled = false;
    (async () => {
      const account = selectedAsset.broker === 'okx' ? userProfile?.name : selectedAsset.account;
      const status = await getInstrumentSync(
        selectedAsset.symbol,
        selectedAsset.broker,
        account,
        selectedAsset.sectype,
      );
      if (!cancelled) setInstrumentSync(!!status);
    })();
    return () => { cancelled = true; };
  }, [selectedAsset, userProfile]);

  const handleToggleInstrumentSync = async () => {
    if (!selectedAsset) return;
    const account = selectedAsset.broker === 'okx' ? userProfile?.name : selectedAsset.account;
    const prev = instrumentSync;
    setInstrumentSync(!prev); // optimistic
    const result = await toggleInstrumentSync(
      selectedAsset.symbol,
      selectedAsset.broker,
      account,
      selectedAsset.sectype,
    );
    if (result === null) {
      setInstrumentSync(prev); // revert on failure
    } else {
      setInstrumentSync(!!result);
    }
  };

  // null until fetched; the type filter is for mixed-type brokers only, so with
  // contfut-only on there is nothing to pick between.
  useEffect(() => {
    let cancelled = false;
    fetchContfutOnlyStatus('ib').then((status) => {
      if (!cancelled) setContfutOnly(status);
    });
    return () => { cancelled = true; };
  }, []);

  // sectype belongs in the key: one symbol can now be held as both CONTFUT and
  // STK, and without it the two rows overwrite each other's trading flag.
  const assetTradingKey = (a) => `${a.broker}-${a.account}-${a.symbol}-${a.sectype || ''}`;
  // The row's own flags until the state has caught up with a fresh list, so the
  // first paint is already filtered; a toggle in the state wins over the row.
  const tradingFlagOf = (a) => tradingFlagFor(a, assetTradingFlags, assetTradingKey(a));

  useEffect(() => {
    if (!assets || assets.length === 0) {
      setAssetTradingFlags({});
      return;
    }
    // fetch-assets carries the flags; only rows without them (deep fetch, or a
    // server-side read that failed) are asked for one by one.
    const known = assets.filter((a) => a.trading !== undefined);
    setAssetTradingFlags(Object.fromEntries(known.map((a) => [assetTradingKey(a), a.trading])));
    const missing = assets.filter((a) => a.trading === undefined);
    if (missing.length === 0) return;
    let cancelled = false;
    (async () => {
      const results = await Promise.all(missing.map(async (a) => {
        const account = a.broker === 'okx' ? userProfile?.name : a.account;
        return [assetTradingKey(a), await getTradingInstrument(a.symbol, a.broker, account, a.sectype)];
      }));
      if (cancelled) return;
      const map = {};
      results.forEach(([k, v]) => {
        if (v !== null) map[k] = v;
      });
      setAssetTradingFlags((m) => ({ ...m, ...map }));
    })();
    return () => { cancelled = true; };
  }, [assets, userProfile]);

  const closeTimeframesSocket = () => {
    if (timeframes_ws.current) {
      const currentSocket = timeframes_ws.current;
      currentSocket.onclose = null;
      currentSocket.onerror = null;
      timeframes_ws.current = null;
      currentSocket.close();
    }
    setTimeframesWsConnected(false);
  };

  const connectTimeframesWs = () => {
    if (!selectedAsset) return;
    const currentSocket = new WebSocket(`${process.env.REACT_APP_API_WS_BASE_URL}/fetch-timeframes-socket`);
    timeframes_ws.current = currentSocket;
    const payload = {};
    payload.symbol = selectedAsset.symbol;
    payload.broker = selectedAsset.broker;
    payload.sectype = selectedAsset.sectype;
    payload.account = selectedAsset.broker === 'okx' ? userProfile?.name : selectedAsset.account;
    // counter tab shows the TOS panel, so the socket must speak 'tos'
    payload.strategy = viewMode === 'counter' ? 'tos' : selectedStrategy;
    payload.Authentication = getAuthToken();
    currentSocket.onopen = () => {
      currentSocket.send(JSON.stringify(payload));
      setTimeframesWsConnected(true);
    };
    currentSocket.onclose = () => {
      setTimeframesWsConnected(false);
    };
    currentSocket.onerror = () => {
      setTimeframesWsConnected(false);
    };
    gettingTimeframesData(currentSocket);
  }

  const gettingTimeframesData = useCallback((socket) => {
    if (!socket) return;
    socket.onmessage = (body) => {
      const data = body.data;
      if (data !== 'ping') {
        try {
          const parsedData = JSON.parse(data);
          if (['initial_signals', 'signal_update', 'hit_update'].includes(parsedData.type)) {
            return;
          }

          // Если это не сигнал, значит это данные о таймфреймах
          setTimeframesInfo(parsedData);
          if (typeof parsedData.trading_auto === 'boolean') setTradingAuto(parsedData.trading_auto);
          // const { is_j2f, is_spin_down, is_algo_active } = parsedData;
          // const activeFlagNames = [];
          // if (is_j2f) activeFlagNames.push('J2F');
          // if (is_spin_down) activeFlagNames.push('Spin Down');
          // if (is_algo_active) activeFlagNames.push('Algo Active');
          // setActiveFlags(activeFlagNames);
          // setLampOn(activeFlagNames.length > 0);
        } catch (error) {
          console.error('Ошибка обработки сообщения WebSocket:', error);
        }
      }
    };
  }, []);

  useEffect(() => {
    let cancelled = false;
    const loadSyncSettings = async () => {
      if (isVirtualAccount && virtualAccountId) {
        try {
          const settings = await getVirtualAccountSyncSettings(virtualAccountId);
          if (cancelled) return;
          setVirtualAccountSyncSettings(settings);

          const instrumentsResponse = await getVirtualAccountInstruments(virtualAccountId);
          if (cancelled) return;
          // Never the previous virtual account's list under this one's name.
          setEnabledInstruments(instrumentsResponse?.enabled_instruments || []);
          setEnabledInstrumentsFailed(!instrumentsResponse || !!instrumentsResponse.failed);
          setEnabledInstrumentsFor(virtualAccountId);
        } catch (error) {
          if (cancelled) return;
          console.error('Error loading sync settings:', error);
          setVirtualAccountSyncSettings({
            sync_group_filters: false,
            sync_strength_filters: false,
            sync_counter_side: false,
            sync_tactical_counter: false,
            sync_optimal_counter: false,
            sync_upper_bound: false,
            sync_lower_bound: false,
            sync_active_inactive: false,
            sync_trade_fade: false,
            sync_shabbat: false,
            sync_django: false,
            sync_break_out: false,
            sync_source_positions: false,
            sync_timeframe: false,
            sync_short_term_strategy: false,
            sync_override_contract: false,
            sync_mtms_modules: false,
            sync_mtms_trading_modes: false,
          });
          setEnabledInstruments([]);
          setEnabledInstrumentsFailed(true);
          setEnabledInstrumentsFor(virtualAccountId);
        }
      }
    };

    loadSyncSettings();
    return () => { cancelled = true; };
  }, [isVirtualAccount, virtualAccountId]);

  const shouldShowAsset = (asset) => !isVirtualAccount || isEnabledOnVirtual(asset, enabledInstruments);
  useEffect(() => {
    if (focus) return;
    const loadAssets = async () => {
      if (viewMode === 'counter') {
        // The folder owns the list. Reloading it on every selection would clear
        // the selected instrument, so only a folder change reloads.
        if (loadedCounterFolder.current === (counterFolder?.id ?? null)) return;
        loadedCounterFolder.current = counterFolder?.id ?? null;
        // A slow read of an older folder layout must not land over a newer one.
        const seq = ++assetsLoadSeq.current;
        if (!counterFolder) {
          setAssets([]);
          return;
        }
        const sources = [...new Map(counterFolder.instruments.map(
          (i) => [`${i.broker}|${i.account}`, i]
        )).values()];
        const fetched = await Promise.all(
          sources.map((i) => fetchAssets(i.account, i.broker, true))
        );
        if (seq !== assetsLoadSeq.current) return;
        setAssets(pickFolderAssets(counterFolder.instruments, fetched.flat()));
        return;
      }
      if (viewMode !== 'counter') loadedCounterFolder.current = null;
      const seq = ++assetsLoadSeq.current;
      // A virtual account's list is cut by its enabled instruments; until those
      // are in, the whole book would flash up and then shrink.
      if (isVirtualAccount && enabledInstrumentsFor !== virtualAccountId) {
        setAssets([]);
        return;
      }
      if (selectedAccount && viewMode === 'solo') {
        const includeSynthetic = true;
        const fetchedAssets = await fetchAssets(
          selectedAccount.account,
          selectedAccount.broker,
          includeSynthetic
        );
        if (seq !== assetsLoadSeq.current) return;

        let assetsToProcess;
        if (Array.isArray(fetchedAssets)) {
          assetsToProcess = fetchedAssets;
        } else {
          assetsToProcess = [fetchedAssets];
        }

        const filteredAssets = isVirtualAccount
          ? assetsToProcess.filter(shouldShowAsset)
          : assetsToProcess;

        setAssets(filterAssetsForViewMode(filteredAssets, viewMode));
      } else {
        setAssets([]);
      }
    };
    setwsMounted(false);
    loadAssets();
  }, [viewMode, selectedAccount, accounts, isVirtualAccount, virtualAccountId, enabledInstruments,
    enabledInstrumentsFor, counterFolder]);

  const renderVirtualAccountInfo = () => {
    if (!isVirtualAccount) return null;

    return (
      <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-4">
        <div className="flex items-center justify-between">
          <div>
            <h2 className="text-xl font-semibold text-blue-700">
              Virtual Account: {selectedAccount?.name}
            </h2>
            <p className="text-sm text-blue-600">
              Source: {sourceAccount?.broker.toUpperCase()} - {truncateText(sourceAccount?.account, 12)}
            </p>
            <p className="text-sm text-gray-600">
              {linkedAccounts.length} linked accounts • {enabledInstruments.length} instruments synchronized
            </p>
            {enabledInstrumentsFailed ? (
              <p className="text-sm font-bold text-red-600">Could not load the enabled instruments</p>
            ) : enabledInstrumentsFor === virtualAccountId && enabledInstruments.length === 0 && (
              <p className="text-sm text-gray-600">No instruments enabled — enable some in the sync settings</p>
            )}
          </div>

          <div className="text-right">
            {syncStatus.lastSynced && (
              <p className="text-xs text-gray-500">
                Last: {new Date(syncStatus.lastSynced).toLocaleTimeString()}
              </p>
            )}
          </div>
        </div>

        {enabledInstruments.length > 0 && enabledInstruments.length <= 5 && (
          <div className="mt-2 p-2 bg-blue-100 border border-blue-200 rounded text-sm">
            <p className="font-semibold text-blue-700">Synchronized instruments:</p>
            <div className="flex flex-wrap gap-1 mt-1">
              {enabledInstruments.map((instr, index) => (
                <span key={index} className="inline-flex items-center px-2 py-1 bg-blue-500 text-white text-xs rounded">
                  {instr.symbol}{instr.sectype && ` (${instr.sectype})`}
                </span>
              ))}
            </div>
          </div>
        )}

        {assetCompatibility.incompatible && assetCompatibility.incompatible.length > 0 && (
          <div className="mt-2 p-2 bg-yellow-50 border border-yellow-200 rounded text-sm">
            <p className="font-semibold text-yellow-700">Warning: Some assets are not available in all linked accounts</p>
            <p className="text-yellow-600">
              {assetCompatibility.incompatible.length} assets may not sync correctly
            </p>
          </div>
        )}
      </div>
    );
  };

  const shouldSyncOperation = (operationType) => {
    if (!virtualAccountSyncSettings) return false;

    const operationMapping = {
      // Counter operations
      'toggleCounterHidden': 'sync_group_filters',
      'toggleStrengthFilter': 'sync_strength_filters',
      'setCounterSide': 'sync_counter_side',
      'setCounterState': (level) => {
        if (level === 'tactical') return 'sync_tactical_counter';
        if (level === 'optimal') return 'sync_optimal_counter';
        return false;
      },
      'setTradingBound': (boundName) => {
        if (boundName === 'upper_bound') return 'sync_upper_bound';
        if (boundName === 'lower_bound') return 'sync_lower_bound';
        return false;
      },

      // Asset operations
      'toggleActive': 'sync_active_inactive',
      'setFade': 'sync_trade_fade',

      // Strategy operations
      'setSTS': 'sync_short_term_strategy',
      'setJ2F': 'sync_shabbat',
      'toggleSpinDown': 'sync_shabbat',
      'setJoeRider': 'sync_django',
      'setTacticalStart': 'sync_break_out',

      // Position operations
      'changeActiveSource': 'sync_source_positions',
      'toggleSide': 'sync_source_positions',

      // Timeframe operations
      'setTimeframeSide': 'sync_timeframe',
      'updateAssetConfig': 'sync_timeframe',

      // MTMS operations
      'setModuleState': 'sync_mtms_modules',
      'setTradableWaves': 'sync_mtms_trading_modes',
      'setTOSQuantity': 'sync_mtms_trading_modes',
      'toggleTOSShabbat': 'sync_shabbat',

      // Override contract
      'setPatch': 'sync_override_contract',
    };

    const settingKey = operationMapping[operationType];
    if (typeof settingKey === 'function') {
      // For operations that need additional context
      return settingKey;
    }

    return virtualAccountSyncSettings[settingKey] || false;
  };


  useEffect(() => {
    const loadData = async () => {
      if (selectedAsset) {
        switch (selectedAsset.broker) {
          case "okx":
            setTVSymbol(`OKX:${reversePatchCrypto(selectedAsset.symbol)}`);
            break;
          case "ig":
          case "ib":
            const reversedPatch = reversePatchSec(
              selectedAsset.symbol,
              selectedAsset.sectype
            );
            setTVSymbol(`${(reversedPatch[1] === undefined) ?
              (selectedAsset.exchange) :
              (reversedPatch[1])}:${reversedPatch[0]}`);
            break;
          default:
            break;
        }
        const fetchedStatistics = await fetchData(
          selectedAccount.broker,
          selectedAsset.broker === 'okx' ? userProfile?.name : selectedAccount.account,
          selectedAsset.symbol,
          selectedAsset.sectype
        );
        setStatistics(fetchedStatistics.raw_data);
      }
    };
    const refreshMasterStatus = async () => {
      try {
        const newStatus = await fetchMasterStatus(selectedAsset.broker);
        setMasterSwitch(newStatus.status);
        setwsMounted(true);
      } catch (error) {
        console.error('Ошибка при обновлении состояния брокера:', error);
      }
    };
    setwsMounted(false);
    if (!skipFetchFlag) {
      loadData();
      if (selectedAsset) {
        refreshMasterStatus();
      }
    } else {
      setwsMounted(true);
      setSkipFetchFlag(false);
    }
  }, [selectedAsset]);

  // Solo view: show instrument (and IB account) in the browser tab title.
  useEffect(() => {
    if (viewMode === 'solo' && selectedAsset) {
      const account = selectedAsset.broker === 'okx' ? null : (selectedAsset.account || selectedAccount?.account);
      document.title = account ? `${selectedAsset.symbol} • ${account}` : selectedAsset.symbol;
    } else {
      document.title = 'Mozart Trader';
    }
    return () => { document.title = 'Mozart Trader'; };
  }, [viewMode, selectedAsset, selectedAccount]);

  useEffect(() => {
    if (viewMode === 'solo' && timeframesInfo) {
      const activeIndex = timeframes.indexOf(timeframesInfo.active_timeframe);
      const nextIndex = Math.min(activeIndex + 1, timeframes.length - 1);
      setSeniorTimeframe(timeframes[nextIndex]);
    }
  }, [timeframesInfo]);


  const synchronizeChangesToLinkedAccounts = async (updateFunction, ...params) => {
    if (!isVirtualAccount || !linkedAccounts.length) {
      return updateFunction(...params);
    }

    // Determine operation type from function name
    const operationType = updateFunction.name;

    // Check if this operation should be synced based on settings
    const shouldSync = shouldSyncOperation(operationType);

    // Handle special cases where we need to check parameters
    if (typeof shouldSync === 'function') {
      // For operations like setCounterState that need to check the level parameter
      const contextParam = params.find(p => ['tactical', 'optimal', 'strategic'].includes(p)) ||
        params.find(p => ['upper_bound', 'lower_bound'].includes(p));
      const settingKey = shouldSync(contextParam);
      if (!virtualAccountSyncSettings[settingKey]) {
        // Don't sync this operation, just execute on source
        return updateFunction(...params);
      }
    } else if (!shouldSync) {
      // Operation should not be synced based on settings
      return updateFunction(...params);
    }

    // Continue with existing synchronization logic...
    const hasAssetObject = params.length > 1 && params[1] && typeof params[1] === 'object' && params[1].symbol;
    const assetToUse = hasAssetObject ? params[1] : selectedAsset;

    if (!assetToUse || !assetToUse.symbol) {
      console.error("No valid asset available for synchronization", { params, selectedAsset });
      return updateFunction(...params);
    }

    setSyncStatus({ ...syncStatus, inProgress: true });

    try {
      // Execute on source account
      const result = await updateFunction(...params);

      // Get target accounts
      const targetAccounts = linkedAccounts.filter(acc =>
        !acc.is_source && acc.broker === 'ib'
      );

      if (targetAccounts.length === 0) {
        setSyncStatus({
          inProgress: false,
          lastSynced: new Date().toISOString(),
          success: true
        });
        return result;
      }

      const currentSymbol = assetToUse.symbol;
      const currentSectype = assetToUse.sectype;

      let successCount = 0;
      let failedAccounts = [];

      // Sync to target accounts
      for (const linkedAccount of targetAccounts) {
        try {

          // Prepare parameters for linked account
          const newParams = [...params];

          // Update account and broker parameters based on function type
          let accountIndex = -1;
          let brokerIndex = -1;

          // Function-specific parameter mapping
          if (updateFunction === updateAssetConfig) {
            accountIndex = 6;
            brokerIndex = 1;
          } else if (updateFunction === setTimeframeSide) {
            accountIndex = 5;
            brokerIndex = 2;
          } else if (updateFunction === setJ2F) {
            accountIndex = 4;
            brokerIndex = 2;
          } else {
            accountIndex = params.findIndex(p =>
              typeof p === 'string' && p === (hasAssetObject ? assetToUse.account : selectedAccount.account)
            );
            brokerIndex = params.findIndex(p =>
              typeof p === 'string' && p === (hasAssetObject ? assetToUse.broker : selectedAccount.broker)
            );
          }

          if (accountIndex !== -1) {
            newParams[accountIndex] = linkedAccount.account;
          }

          if (brokerIndex !== -1) {
            newParams[brokerIndex] = linkedAccount.broker;
          }

          if (updateFunction === updateAssetConfig && linkedAccount.broker === 'ib') {
            newParams[newParams.length - 1] = null;
          }

          // Execute on linked account
          await updateFunction(...newParams);
          successCount++;
        } catch (error) {
          console.error(`Sync error with account ${linkedAccount.account}:`, error);
          failedAccounts.push({
            account: linkedAccount.account,
            error: error.message
          });
        }
      }

      const allSuccessful = failedAccounts.length === 0;
      setSyncStatus({
        inProgress: false,
        lastSynced: new Date().toISOString(),
        success: allSuccessful,
        failedAccounts: failedAccounts.length > 0 ? failedAccounts : undefined
      });

      // if (successCount > 0) {
      //   try {
      //     await syncVirtualAccountAssets(virtualAccountId);
      //   } catch (error) {
      //     console.error('Server synchronization error:', error);
      //   }
      // }

      return result;
    } catch (error) {
      console.error('Error synchronizing changes:', error);
      setSyncStatus({
        inProgress: false,
        lastSynced: new Date().toISOString(),
        success: false,
        error: error.message
      });
      throw error;
    }
  };

  const handleDeepFetch = async () => {
    if (selectedAccount) {
      setIsFetching(true);
      try {
        const fetchedDeepAssets = await fetchDeepAssets(
          selectedAccount.broker,
          selectedAccount.account
        );
        setAssets(fetchedDeepAssets);
      } catch (error) {
        console.error('Error during deep fetch:', error);
      } finally {
        setIsFetching(false);
      }
    }
  };

  const handleAccountSelect = (account, { toggle = true } = {}) => {
    const nextSelection = toggle ? reduceAccountSelection(
      {
        isVirtualAccount,
        virtualAccountId,
        sourceAccount,
        linkedAccounts,
        selectedAccount: tradingAccount,
      },
      account
    ) : buildSelectionStateFromAccount(account);

    setIsVirtualAccount(nextSelection.isVirtualAccount);
    setVirtualAccountId(nextSelection.virtualAccountId);
    setSourceAccount(nextSelection.sourceAccount);
    setLinkedAccounts(nextSelection.linkedAccounts);
    setTradingAccount(nextSelection.selectedAccount);
    setSelectedAsset(null);
    setwsMounted(false);
  };

  const handleScannerPromotion = (broker, account) => {
    // OKX promotion uses the username, while the account list holds the linked account name.
    const target = accounts.find((a) => a.broker === broker && a.account === account)
      || (broker === 'okx' && accounts.find((a) => a.broker === 'okx'));
    // Reload even if the operator has already opened the target while the move was pending.
    if (target) handleAccountSelect({ ...target }, { toggle: false });
  };

  // A notification carries only the symbol, and switching account reloads the
  // asset list, so the pick waits for the new assets to arrive.
  const pendingAssetSymbol = useRef(null);

  const handleAccountNotificationSelect = (account, n) => {
    handleAccountSelect(account);
    if (!['solo', 'counter'].includes(viewMode)) setViewMode('solo');
    const symbol = n?.symbol;
    if (!symbol) return;
    // Set both ways: the effect below covers the reload, the direct call covers
    // the case where nothing reloads and the effect never fires.
    pendingAssetSymbol.current = symbol;
    const asset = assets.find((a) => a.symbol === symbol && a.broker === account.broker);
    if (asset) handleAssetSelect(asset);
  };

  // COUNTER picks an instrument, not an account: the account behind it rides on
  // the asset itself, so the panels keep addressing the namespaces the trading
  // view writes to.
  const handleCounterAssetSelect = (asset) => {
    setCounterAccount({
      id: `folder-${asset.broker}-${asset.account}`,
      broker: asset.broker,
      account: asset.account,
    });
    handleAssetSelect(asset);
  };

  // A folder feed click jumps to the instrument the notification is about.
  const handleCounterNotificationSelect = (n) => {
    const asset = folderAssetOf(assets, n);
    if (asset && !folderAssetOf([selectedAsset], n)) handleCounterAssetSelect(asset);
  };

  const handleOpenCounterFolder = (folder, instruments) => {
    setCounterFolder({ ...folder, instruments });
    setSelectedAsset(null);
    // Until a parent is picked the panels read a stand-in account.
    setStaleParents(instruments.filter((i) => i.needs_parent));
  };

  const answerStaleParent = async (account) => {
    const [instrument, ...rest] = staleParents;
    await addInstrumentToFolder(counterFolder.id, instrument, account);
    setStaleParents(rest);
    refreshCounterFolder();
  };

  // Refresh and BACK from the library both re-read the library; the folder tiles
  // hand every read here and the open folder is rebuilt from it.
  const refreshCounterFolder = () => {
    setCounterRefreshing(true);
    setCounterRefreshFailed(false);
    setLibraryRevision((revision) => revision + 1);
  };

  const handleFolderLibraryLoaded = (library) => {
    setCounterRefreshing(false);
    setCounterRefreshFailed(false);
    if (!counterFolder) return;
    const fresh = refreshOpenFolder(counterFolder, library);
    if (fresh === counterFolder) {
      // Nothing moved, but a dismissed parent question is still owed.
      setStaleParents(folderStaleParents(library, counterFolder.id));
      return;
    }
    if (!fresh) {
      handleLeaveCounterFolder();
      return;
    }
    loadedCounterFolder.current = null;
    handleOpenCounterFolder(fresh, fresh.instruments);
  };

  const handleFolderLibraryFailed = () => {
    setCounterRefreshing(false);
    setCounterRefreshFailed(true);
  };

  const handleLeaveCounterFolder = () => {
    setCounterFolder(null);
    setSelectedAsset(null);
    setCounterAccount(null);
    setStaleParents([]);
  };

  const handleAssetSelect = (asset) => {
    setTVSymbol(null);
    setStatistics(null);
    setwsMounted(false);
    setSeniorTimeframe(null);
    setSelectedAsset(asset);
  };

  // COUNTER reuses the TOS panel over the tos store, so its TOS writes address
  // the 'tos' namespace even though the tab's strategy is 'counter'.
  const tosStrategy = viewMode === 'counter' ? 'tos' : selectedStrategy;

  const handleSetLeverage = async (symbol, broker, timeframe, leverage) => {
    if (isVirtualAccount) {
      return synchronizeChangesToLinkedAccounts(
        setLeverage,
        symbol,
        broker,
        timeframe,
        tosStrategy,
        userProfile?.name,
        leverage
      );
    } else {
      return await setLeverage(
        symbol,
        broker,
        timeframe,
        tosStrategy,
        userProfile?.name,
        leverage
      );
    }
  };

  const handleSetPatch = async (active, local_symbol, multiplier) => {
    const patchAccount = selectedAsset.broker === 'okx'
      ? userProfile.name
      : selectedAsset.account || selectedAccount?.account;

    if (isVirtualAccount) {
      return synchronizeChangesToLinkedAccounts(
        setPatch,
        selectedAsset.symbol,
        selectedAsset.broker,
        patchAccount,
        selectedStrategy,
        active,
        local_symbol,
        multiplier,
        selectedAsset.sectype
      );
    } else {
      return await setPatch(
        selectedAsset.symbol,
        selectedAsset.broker,
        patchAccount,
        selectedStrategy,
        active,
        local_symbol,
        multiplier,
        selectedAsset.sectype
      );
    }
  };


  const handleSetSyntheticTROS = async (
    symbol,
    broker,
    tros_stage,
    upper_bound,
    lower_bound,
    tros_side,
    timeframe,
    account,
    sectype
  ) => {
    if (isVirtualAccount) {
      return synchronizeChangesToLinkedAccounts(
        setSyntheticTROS,
        symbol,
        broker,
        tros_stage,
        upper_bound,
        lower_bound,
        tros_side,
        timeframe,
        broker === 'okx' ? userProfile?.name : account,
        selectedStrategy,
        sectype
      );
    } else {
      return await setSyntheticTROS(
        symbol,
        broker,
        tros_stage,
        upper_bound,
        lower_bound,
        tros_side,
        timeframe,
        broker === 'okx' ? userProfile?.name : account,
        selectedStrategy,
        sectype
      );
    }
  };

  const handleSetSTS = async (
    sts_object
  ) => {
    if (isVirtualAccount) {
      return synchronizeChangesToLinkedAccounts(
        setSTS,
        selectedAsset.symbol,
        selectedAsset.broker,
        sts_object.updown_target,
        sts_object.fade_target,
        sts_object.upper_bound,
        sts_object.lower_bound,
        sts_object.j2s_target,
        sts_object.j2f_target,
        sts_object.shabbat,
        sts_object.fade_shabbat,
        selectedAsset.broker === 'okx' ? userProfile?.name : selectedAsset.account,
        selectedStrategy,
        selectedAsset.sectype,
        timeframesInfo.active_timeframe
      );
    } else {
      return await setSTS(
        selectedAsset.symbol,
        selectedAsset.broker,
        sts_object.updown_target,
        sts_object.fade_target,
        sts_object.upper_bound,
        sts_object.lower_bound,
        sts_object.j2s_target,
        sts_object.j2f_target,
        sts_object.shabbat,
        sts_object.fade_shabbat,
        selectedAsset.broker === 'okx' ? userProfile?.name : selectedAsset.account,
        selectedStrategy,
        selectedAsset.sectype,
        timeframesInfo.active_timeframe
      );
    }
  };

  const handleCounterStateChange = async (
    counter_state,
    level,
    group,
    symbol,
    broker,
    sectype,
    timeframe,
    strategy,
    account,
    targetTimeframe = null,
    // COUNTER pins the backend view to 'solo' so its writes share solo's tos
    // storage/side-effects; solo/unified omit it and keep viewMode.
    viewOverride = null
  ) => {
    const effectiveView = viewOverride || viewMode;
    if (
      symbol !== undefined &&
      broker !== undefined &&
      sectype !== undefined &&
      timeframe !== undefined &&
      account !== undefined &&
      strategy !== undefined &&
      (!selectedAsset || !timeframesInfo)
    ) { }
    else if (!selectedAsset || !timeframesInfo) { return null; }
    else {
      symbol = selectedAsset.symbol;
      broker = selectedAsset.broker;
      sectype = selectedAsset.sectype;
      account = selectedAsset.account;
      timeframe = timeframesInfo.active_timeframe;
    }
    if (strategy === undefined) {
      strategy = 'counter';
    }
    if (isVirtualAccount) {
      return synchronizeChangesToLinkedAccounts(
        setCounterState,
        symbol,
        broker,
        broker === 'okx' ? userProfile?.name : account,
        sectype,
        counter_state,
        group,
        level,
        strategy,
        effectiveView,
        targetTimeframe
      );
    } else {
      return await setCounterState(
        symbol,
        broker,
        broker === 'okx' ? userProfile?.name : account,
        sectype,
        counter_state,
        group,
        level,
        strategy,
        effectiveView,
        targetTimeframe
      );
    }
  };

  // COUNTER wrapper: append viewOverride='solo' to TOSPanel's 10-arg call.
  const handleCounterTosStateChange = (
    counter_state, level, group, symbol, broker, sectype, timeframe, strategy, account, targetTimeframe = null
  ) => handleCounterStateChange(
    counter_state, level, group, symbol, broker, sectype, timeframe, strategy, account, targetTimeframe, 'solo'
  );

  const handleTOSPatch = async (
    tos_object,
    target_timeframe,
    bindings = null,
    // A caller may pass its own asset; otherwise the selection.
    asset = null
  ) => {
    const targetAsset = asset || selectedAsset;
    if (!targetAsset) return null;
    const targetTimeframe = target_timeframe || timeframesInfo?.active_timeframe;

    if (isVirtualAccount) {
      return synchronizeChangesToLinkedAccounts(
        setTOSPatch,
        targetAsset.symbol,
        targetAsset.broker,
        targetAsset.broker === 'okx' ? userProfile?.name : targetAsset.account,
        tosStrategy,
        targetAsset.sectype,
        targetTimeframe,
        tos_object["tactical"],
        tos_object["optimal"],
        tos_object["strategic"],
        bindings
      );
    } else {
      return await setTOSPatch(
        targetAsset.symbol,
        targetAsset.broker,
        targetAsset.broker === 'okx' ? userProfile?.name : targetAsset.account,
        tosStrategy,
        targetAsset.sectype,
        targetTimeframe,
        tos_object["tactical"],
        tos_object["optimal"],
        tos_object["strategic"],
        bindings
      );
    }
  };

  const handleSetTOSQuantity = async (
    level,
    quantity,
    symbol,
    broker,
    sectype,
    timeframe,
    account
  ) => {
    // if (!selectedAsset || !timeframesInfo) return null;
    if (
      symbol !== undefined &&
      broker !== undefined &&
      timeframe !== undefined &&
      (!selectedAsset || !timeframesInfo)
    ) { }
    else if (!selectedAsset || !timeframesInfo) { return null; }
    else {
      symbol = selectedAsset.symbol;
      broker = selectedAsset.broker;
      sectype = selectedAsset.sectype;
      account = selectedAccount.account
      timeframe = timeframesInfo.active_timeframe;
    }

    if (isVirtualAccount) {
      return synchronizeChangesToLinkedAccounts(
        setTOSQuantity,
        symbol,
        broker,
        broker === 'okx' ? userProfile?.name : account,
        sectype,
        tosStrategy,
        timeframe,
        level,
        quantity
      );
    } else {
      return await setTOSQuantity(
        symbol,
        broker,
        broker === 'okx' ? userProfile?.name : account,
        sectype,
        tosStrategy,
        timeframe,
        level,
        quantity
      );
    }
  };

  const handleChangeActivePos = async (sourceName, asset, timeframe) => {
    if (!asset) {
      console.error("No asset provided to handleChangeActivePos");
      return null;
    }
    if (isVirtualAccount) {
      return synchronizeChangesToLinkedAccounts(
        changeActiveSource,
        sourceName,
        asset.symbol,
        asset.broker,
        timeframe,
        tosStrategy,
        asset.broker === 'okx' ? userProfile?.name : asset.account,
        asset.sectype,
        true
      );
    } else {
      return await changeActiveSource(
        sourceName,
        asset.symbol,
        asset.broker,
        timeframe,
        tosStrategy,
        asset.broker === 'okx' ? userProfile?.name : asset.account,
        asset.sectype
      );
    }
  };

  const handleToggleSide = async (sourceName, asset, timeframe) => {
    try {
      if (isVirtualAccount) {
        return synchronizeChangesToLinkedAccounts(
          toggleSide,
          sourceName,
          viewMode === 'solo' ? selectedAsset.symbol : asset.symbol,
          viewMode === 'solo' ? selectedAsset.broker : asset.broker,
          timeframe,
          viewMode === 'solo' ? selectedAsset.account : asset.account,
          viewMode === 'solo' ? selectedAsset.sectype : asset.sectype
        );
      } else {
        if (viewMode === 'solo') {
          return await toggleSide(
            sourceName,
            selectedAsset.symbol,
            selectedAsset.broker,
            timeframe,
            selectedAsset.account,
            selectedAsset.sectype
          );
        } else {
          return await toggleSide(
            sourceName,
            asset.symbol,
            asset.broker,
            timeframe,
            asset.account,
            asset.sectype
          );
        }
      }
    } catch (error) {
      console.error("Error toggling side:", error);
    }
  };

  const handleSetTimeframeSideClick = async (side, timeframe) => {
    try {
      if (isVirtualAccount) {
        return synchronizeChangesToLinkedAccounts(
          setTimeframeSide,
          side,
          selectedAsset.symbol,
          selectedAsset.broker,
          selectedStrategy,
          timeframe,
          selectedAsset.broker === 'okx' ? userProfile.name : selectedAsset.account,
          selectedAsset.sectype
        );
      } else {
        return await setTimeframeSide(
          side,
          selectedAsset.symbol,
          selectedAsset.broker,
          selectedStrategy,
          timeframe,
          selectedAsset.broker === 'okx' ? userProfile?.name : selectedAsset.account,
          selectedAsset.sectype
        );
      }
    } catch (error) {
      console.error("Error toggling side:", error);
    }
  };

  const handleSetJ2F = async (timeframe, isJ2F) => {
    try {
      if (isVirtualAccount) {
        return synchronizeChangesToLinkedAccounts(
          setJ2F,
          isJ2F,
          selectedAsset.symbol,
          selectedAsset.broker,
          timeframe,
          selectedStrategy,
          selectedAsset.broker === 'okx' ? userProfile.name : selectedAsset.account,
          selectedAsset.sectype
        );
      } else {
        return await setJ2F(
          isJ2F,
          selectedAsset.symbol,
          selectedAsset.broker,
          timeframe,
          selectedStrategy,
          selectedAsset.broker === 'okx' ? userProfile?.name : selectedAsset.account,
          selectedAsset.sectype
        );
      }
    } catch (error) {
      console.error("Error setting J2F:", error);
    }
  };

  const handleSetTimeframeMetaAutoresolve = async (status) => {
    try {
      // Per asset, so no timeframe/strategy in the payload.
      const args = [
        status,
        selectedAsset.symbol,
        selectedAsset.broker,
        selectedAsset.broker === 'okx' ? userProfile.name : selectedAsset.account,
        selectedAsset.sectype,
      ];
      if (isVirtualAccount) {
        const response = await synchronizeChangesToLinkedAccounts(
          setTimeframeMetaAutoresolve, ...args
        );
        if (response) {
          try {
            await syncVirtualAccountAssets(virtualAccountId);
          } catch (syncError) {
            console.error("Error syncing after autoresolve change:", syncError);
          }
        }
        return response;
      }
      return await setTimeframeMetaAutoresolve(...args);
    } catch (error) {
      console.error("Error setting timeframe meta autoresolve:", error);
      return null;
    }
  };

  const handleSetJoeRider = async (isJoeRider) => {
    try {
      if (isVirtualAccount) {
        const response = await synchronizeChangesToLinkedAccounts(
          setJoeRider,
          isJoeRider,
          selectedAsset.symbol,
          selectedAsset.broker,
          timeframesInfo.active_timeframe,
          selectedStrategy,
          selectedAsset.broker === 'okx' ? userProfile.name : selectedAsset.account,
          selectedAsset.sectype
        );
        if (response) {
          try {
            await syncVirtualAccountAssets(virtualAccountId);
          } catch (syncError) {
            console.error("Error syncing after JoeRider change:", syncError);
          }
        }

        return response;
      } else {
        return await setJoeRider(
          isJoeRider,
          selectedAsset.symbol,
          selectedAsset.broker,
          timeframesInfo.active_timeframe,
          selectedStrategy,
          selectedAsset.broker === 'okx' ? userProfile?.name : selectedAsset.account,
          selectedAsset.sectype
        );
      }
    } catch (error) {
      console.error("Error setting Joe Rider:", error);
      throw error;  // Propagate the error for proper handling by the caller
    }
  };
  const handleSetTacticalStart = async (status) => {
    try {
      if (isVirtualAccount) {
        const response = await synchronizeChangesToLinkedAccounts(
          setTacticalStart,
          status,
          selectedAsset.symbol,
          selectedAsset.broker,
          timeframesInfo.active_timeframe,
          selectedStrategy,
          selectedAsset.broker === 'okx' ? userProfile.name : selectedAsset.account,
          selectedAsset.sectype
        );
        if (response) {
          try {
            await syncVirtualAccountAssets(virtualAccountId);
          } catch (syncError) {
            console.error("Error syncing after JoeRider change:", syncError);
          }
        }

        return response;
      } else {
        return await setTacticalStart(
          status,
          selectedAsset.symbol,
          selectedAsset.broker,
          timeframesInfo.active_timeframe,
          selectedStrategy,
          selectedAsset.broker === 'okx' ? userProfile?.name : selectedAsset.account,
          selectedAsset.sectype
        );
      }
    } catch (error) {
      console.error("Error setting Joe Rider:", error);
      throw error;  // Propagate the error for proper handling by the caller
    }
  };

  const handleSetUpdown = async (status) => {
    try {
      if (isVirtualAccount) {
        const response = await synchronizeChangesToLinkedAccounts(
          setUpdown,
          status,
          selectedAsset.symbol,
          selectedAsset.broker,
          timeframesInfo.active_timeframe,
          selectedStrategy,
          selectedAsset.broker === 'okx' ? userProfile.name : selectedAsset.account,
          selectedAsset.sectype
        );
        if (response) {
          try {
            await syncVirtualAccountAssets(virtualAccountId);
          } catch (syncError) {
            console.error("Error syncing after Updown change:", syncError);
          }
        }

        return response;
      } else {
        return await setUpdown(
          status,
          selectedAsset.symbol,
          selectedAsset.broker,
          timeframesInfo.active_timeframe,
          selectedStrategy,
          selectedAsset.broker === 'okx' ? userProfile?.name : selectedAsset.account,
          selectedAsset.sectype
        );
      }
    } catch (error) {
      console.error("Error setting Updown:", error);
      throw error;  // Propagate the error for proper handling by the caller
    }
  };

  const handleToggleSpinDown = async () => {
    try {
      if (isVirtualAccount) {
        return synchronizeChangesToLinkedAccounts(
          toggleSpinDown,
          selectedAsset.symbol,
          selectedAsset.broker,
          selectedAsset.account,
          selectedAsset.sectype
        );
      } else {
        return await toggleSpinDown(
          selectedAsset.symbol,
          selectedAsset.broker,
          selectedAsset.account,
          selectedAsset.sectype
        );
      }
    } catch (error) {
      console.error("Error toggling spin down:", error);
    }
  };

  const handleToggleActiveAssetClick = async () => {
    try {

      if (selectedStrategy === 'tos' && viewMode === 'solo') {
        let symbol = selectedAsset.symbol || selectedAsset.epic;
        let broker = selectedAsset.broker;
        let account = selectedAsset.account || null;
        let sectype = selectedAsset.sectype || '';

        if (!symbol && broker && (broker.includes('/') || broker.includes(':') || broker.includes('-') || broker.includes('_'))) {
            symbol = broker;
            broker = selectedAsset.account;
            account = (broker === 'okx') ? userProfile?.name : selectedAsset.sectype || null;
            sectype = null;
        } else if (broker === 'okx') {
            account = userProfile?.name || account;
        }

        const cleanupResult = await cleanupTosActiveState(
          symbol,
          broker,
          account,
          sectype,
          timeframesInfo?.active_timeframe,
        );

        if (cleanupResult === null) {
          alert('Не удалось выполнить cleanup active режима. Проверьте логи.');
          return null;
        }

        setSkipFetchFlag(true);
        return cleanupResult;
      }

      if (isVirtualAccount) {
        const result = await synchronizeChangesToLinkedAccounts(
          toggleActive,
          selectedAsset.symbol || selectedAsset.epic,
          selectedAsset.broker,
          selectedAsset.account || null,
          selectedAsset.sectype || ''
        );

        if (result !== null) {
          await handleDeepFetch();
          setSkipFetchFlag(true);
          handleAssetSelect(null);
        } else {
          alert('Не удалось переключить active режим. Проверьте логи.');
        }

        return result;
      } else {
        const newStatus = await toggleActive(
          selectedAsset.symbol || selectedAsset.epic,
          selectedAsset.broker,
          selectedAsset.account || null,
          selectedAsset.sectype || ''
        );

        if (newStatus !== null) {
          await handleDeepFetch();
          setSkipFetchFlag(true);
          handleAssetSelect(null);
        } else {
          alert('Не удалось переключить active режим. Проверьте логи.');
        }

        return newStatus;
      }
    } catch (error) {
      console.error('Ошибка при переключении активности актива:', error);
    }
  };

  const handleSetFadeClick = async (status) => {
    if (isVirtualAccount) {
      return synchronizeChangesToLinkedAccounts(
        setFade,
        status,
        selectedAsset.symbol || selectedAsset.epic,
        selectedAsset.broker,
        selectedStrategy,
        selectedAsset.broker === 'okx' ? userProfile?.name : selectedAsset.account,
        selectedAsset.sectype || '',
        timeframesInfo.active_timeframe,
      );
    } else {
      return await setFade(
        status,
        selectedAsset.symbol || selectedAsset.epic,
        selectedAsset.broker,
        selectedStrategy,
        selectedAsset.broker === 'okx' ? userProfile?.name : selectedAsset.account,
        selectedAsset.sectype || '',
        timeframesInfo.active_timeframe,
      );
    }
  };

  const handleMasterSwitchClick = async (broker) => {
    try {
      if (isVirtualAccount) {
        // For virtual accounts, we need to switch master for all linked brokers
        const sourceResult = await switchMaster(broker);
        setMasterSwitch(sourceResult);

        // Get unique brokers from linked accounts
        const linkedBrokers = [...new Set(linkedAccounts.map(acc => acc.broker))];

        // Switch master for each linked broker
        for (const linkedBroker of linkedBrokers) {
          if (linkedBroker !== broker) {
            await switchMaster(linkedBroker);
          }
        }

        return sourceResult;
      } else {
        const newStatus = await switchMaster(broker);
        setMasterSwitch(newStatus);
        return newStatus;
      }
    } catch (error) {
      console.error('Ошибка при переключении мастера:', error);
    }
  };

  useEffect(() => {
    setwsMounted(true);
    setSelectedAsset(null);
  }, [viewMode, assets, selectedStrategy]);

  // After the effect above, which clears the selection on mount.
  useEffect(() => {
    if (focusAsset) handleAssetSelect(focusAsset);
  }, [focusAsset]);

  // Must run after the effect above, which clears the selection whenever the
  // asset list reloads.
  useEffect(() => {
    // The list can still be the previous account's on the first pass, so the
    // pending symbol is kept until it actually resolves.
    const symbol = pendingAssetSymbol.current;
    if (!symbol) return;
    const asset = assets.find((a) => a.symbol === symbol);
    if (!asset) return;
    pendingAssetSymbol.current = null;
    handleAssetSelect(asset);
  }, [assets, viewMode, selectedStrategy]);


  // COUNTER | TOS (Solo). GYROX, Unified and Helicopter are gone from the UI.
  const handleStrategyChange = (index) => {
    setViewMode(index === 0 ? 'counter' : 'solo');
    setwsMounted(false);
    setSelectedStrategy(index === 0 ? 'counter' : 'tos');
  };

  const showTypeFilter = isInstrumentTypeFilterEnabled()
    && contfutOnly === false
    && assets.some((a) => a.broker === 'ib');

  const handleAssetTransferred = async (asset) => {
    await handleDeepFetch();
    setSkipFetchFlag(true);

    if (selectedAsset && selectedAsset.symbol === asset.symbol) {
      handleAssetSelect(null);
    }

    alert(`Asset ${asset.symbol} has been transferred to main table successfully!`);
  };

  return (
    <div className={focus ? 'space-y-4' : 'space-y-8'}>
      <AuthErrorModal
        isOpen={showAuthErrorModal}
        onClose={() => setShowAuthErrorModal(false)}
      />
      {!focus && (<>
      <h1 className="text-3xl font-bold">Dashboard</h1>

      {renderVirtualAccountInfo()}

      {viewMode === 'solo' && selectedStrategy === 'tos' && selectedAsset ? (
        <FolderTabs
          tabs={[{ key: 'accounts', label: 'Accounts' }, { key: 'feed', label: 'Live Feed' }]}
          active={soloTab}
          onChange={setSoloTab}
        >
          {soloTab === 'accounts' ? (
            <div className="p-3">
              <AccountList accounts={accounts} onSelect={handleAccountSelect} onNotificationSelect={handleAccountNotificationSelect} />
            </div>
          ) : (
            <NotificationFeedInline
              framed={false}
              context={{ brokers: [selectedAsset.broker], instruments: [selectedAsset.symbol] }}
              title={`Live feed · ${selectedAsset.symbol}`}
              hits={{
                asset: selectedAsset,
                account: selectedAsset.broker === 'okx' ? userProfile?.name : selectedAccount?.account,
                websocket: timeframes_ws.current,
              }}
            />
          )}
        </FolderTabs>
      ) : viewMode !== 'counter' && (
        <AccountList accounts={accounts} onSelect={handleAccountSelect} onNotificationSelect={handleAccountNotificationSelect} />
      )}

      <div className="mb-4">
        {/* Stretch: the filter and refresh take the toggle's height. */}
        <div className="flex items-stretch gap-3 mb-2">
          <ToggleSwitch
            options={['COUNTER', 'TOS']}
            onToggle={handleStrategyChange}
            active={viewMode === 'counter' ? 0 : 1}
          />
          {viewMode === 'solo' && selectedAccount && (
            <>
              <MultiSelect
                label="Sectype"
                groups={plain(sectypeOptions(assets.filter((a) => tradingFlagOf(a) !== false)))}
                value={tosSectypes}
                onChange={setTosSectypes}
                open={tosSectypeOpen}
                onOpenChange={setTosSectypeOpen}
                align="left"
                buttonClass="px-4 text-sm"
              />
              <button
                className={`flex items-center px-3 bg-white rounded-lg shadow ${isFetching ? 'opacity-30 cursor-not-allowed' : ''}`}
                onClick={handleDeepFetch}
                disabled={isFetching}
                title="Force refresh"
              >
                <img
                  src="https://www.svgrepo.com/show/167751/refresh.svg"
                  alt={isFetching ? "Refreshing" : "Refresh"}
                  className={`h-5 w-5 ${isFetching ? "animate-spin" : ""}`}
                  style={{ animationDirection: "reverse" }}
                />
              </button>
            </>
          )}
        </div>
        <div className="flex items-center">
          {viewMode === 'counter' && (
            <div className="flex items-center gap-2">
              {counterFolder && !showLibrary && (
                <>
                  <button
                    onClick={handleLeaveCounterFolder}
                    className="rounded-lg bg-white px-3 py-2 text-xs font-bold text-gray-500 shadow hover:text-olive-600"
                  >
                    ← FOLDERS
                  </button>
                  <span className="text-sm font-bold text-gray-700">{counterFolder.name}</span>
                  <button
                    onClick={refreshCounterFolder}
                    disabled={counterRefreshing}
                    title="Refresh"
                    className={`rounded-lg bg-white p-2 shadow ${counterRefreshing ? 'cursor-not-allowed opacity-30' : ''}`}
                  >
                    <img
                      src="https://www.svgrepo.com/show/167751/refresh.svg"
                      alt={counterRefreshing ? 'Refreshing' : 'Refresh'}
                      className={`h-4 w-4 ${counterRefreshing ? 'animate-spin' : ''}`}
                      style={{ animationDirection: 'reverse' }}
                    />
                  </button>
                  {counterRefreshFailed && (
                    <span className="text-xs font-bold text-red-600">Could not refresh</span>
                  )}
                </>
              )}
              <button
                onClick={() => {
                  if (showLibrary) refreshCounterFolder();
                  setShowLibrary(!showLibrary);
                  setSelectedAsset(null);
                }}
                className={`rounded-lg px-3 py-2 text-xs font-bold shadow ${
                  showLibrary ? 'bg-olive-500 text-white' : 'bg-white text-gray-500 hover:text-olive-600'
                }`}
              >
                {showLibrary ? '← BACK' : 'LIBRARY'}
              </button>
            </div>
          )}
        </div>
      </div>



      {showTypeFilter && (
        <InstrumentTypeFilter value={instrumentType} onChange={setInstrumentType} />
      )}

      {viewMode === 'solo' && !selectedAccount && (
        <div className="bg-gradient-to-r from-gray-50 to-gray-100 p-6 rounded-xl shadow-md text-center text-gray-700 font-semibold text-lg border border-gray-200">
          Please select an account to view assets
        </div>
      )}

      {viewMode === 'counter' && counterFolder && staleParents.length > 0 && (
        <ParentPicker
          instrument={staleParents[0]}
          accounts={staleParents[0].accounts}
          stale={staleParents[0].parent_account}
          remaining={staleParents.length - 1}
          onPick={answerStaleParent}
          onClose={() => setStaleParents([])}
        />
      )}

      {viewMode === 'counter' && !showLibrary && (
        <div className={counterFolder ? 'mb-4' : ''}>
          <ScannerFolderList
            onOpen={handleOpenCounterFolder}
            reloadSignal={libraryRevision}
            activeId={counterFolder?.id}
            onLoaded={handleFolderLibraryLoaded}
            onFailed={handleFolderLibraryFailed}
          />
        </div>
      )}
      </>)}

      {!focus && viewMode === 'counter' && showLibrary && (
        <ScannerLibrary
          accounts={accounts}
          onSelect={() => {}}
          selectedKey={null}
          onPromoted={handleScannerPromotion}
        />
      )}

      {!focus && viewMode === 'counter' && !showLibrary && counterFolder && (
        <AssetList
          assets={assets.filter((a) => !showTypeFilter || assetMatchesInstrumentType(a, instrumentType))}
          onSelect={handleCounterAssetSelect}
          detailed={false}
          handleDeepFetch={handleDeepFetch}
          isFetching={isFetching}
        />
      )}

      {!focus && viewMode === 'solo' && selectedAccount && (
        <AssetList
          assets={
            assets
              .filter((a) => tradingFlagOf(a) !== false)
              .filter((a) => !showTypeFilter || assetMatchesInstrumentType(a, instrumentType))
              .filter((a) => matchesSectypes(a, tosSectypes))
          }
          onSelect={handleAssetSelect}
          detailed={false}
          handleDeepFetch={handleDeepFetch}
          isFetching={isFetching}
        />
      )}
      {viewMode === 'counter' && selectedAsset && (
        <div className="flex flex-col gap-4 lg:flex-row lg:items-start">
        {/* Holds its width while the next instrument connects, so the feed stays put. */}
        <div className="space-y-4 w-full max-w-md shrink-0">
        {wsMounted && (<>
          {timeframesInfo ? (
            <div className="space-y-2 w-full max-w-md">
              <InstrumentPlacement
                asset={selectedAsset}
                accounts={accounts}
                onChanged={() => setLibraryRevision((n) => n + 1)}
                onPromoted={focus ? undefined : handleScannerPromotion}
              />
              {/* Same TOS panel as tos-solo, minus DU waves / U-L / Qty. */}
              <TOSPanel
                gridLocation=""
                timeframe={timeframesInfo?.active_timeframe}
                asset={selectedAsset}
                isVirtualAccount={isVirtualAccount}
                synchronizeChangesToLinkedAccounts={synchronizeChangesToLinkedAccounts}
                handleChangeActivePos={handleChangeActivePos}
                handleToggleSide={handleToggleSide}
                showAccount={false}
                showDuWaves={false}
                showSideSignals={false}
                showQty={false}
                timeframesCollapsed={!!focus}
                tradingInstrumentActive={tradingInstrument}
                onToggleTradingInstrument={handleToggleTradingInstrument}
                scannerWaveFilter={tradingInstrument ? tradingWaveFilter : scannerWaveFilter}
                onCycleScannerWaveFilter={handleCycleScannerWaveFilter}
                onQuantitySet={handleSetTOSQuantity}
                onTOSPatch={handleTOSPatch}
                handleCounterStateChange={handleCounterTosStateChange}
                handleSetLeverage={handleSetLeverage}
                leverageInitial={timeframesInfo?.leverage}
                username={userProfile?.name}
                onReconnect={() => {
                  closeTimeframesSocket();
                  connectTimeframesWs();
                }}
              />
            </div>
          ) : (
            <div className="py-8 text-center text-gray-500">Connecting to TOS…</div>
          )}
          {selectedAccount && !focus && (
            <SyntheticAssetsManager
              selectedAccount={selectedAccount}
              selectedBroker={selectedAccount.broker}
              selectedAsset={selectedAsset}
              onAssetTransferred={handleAssetTransferred}
            />
          )}
        </>)}
        </div>
        {/* Outside the wsMounted gate: switching instruments must not reset the feed. */}
        {/* Focus mode lives next to its own feed. */}
        {!focus && <div className="w-full min-w-0 lg:flex-1">
          <NotificationFeedInline
            context={{ pairs: [selectedAsset, ...assets].map((a) => `${a.broker}|${a.symbol}`) }}
            title={`Live feed · ${counterFolder?.name || selectedAsset.symbol}`}
            hits={{
              asset: selectedAsset,
              account: selectedAsset.broker === 'okx' ? userProfile?.name : selectedAccount?.account,
              websocket: timeframes_ws.current,
            }}
            onSelectItem={handleCounterNotificationSelect}
          />
        </div>}
        </div>
      )}

      {viewMode === 'solo' && selectedAsset && masterSwitch !== null && wsMounted && timeframesInfo && seniorTimeframe && (
        <div className="grid grid-cols-1 grid-rows-auto sm:grid-cols-3 gap-4">
          <div className="sm:col-start-1 sm:col-end-1 sm:row-start-1 sm:row-end-1 col-start-1 col-end-1 row-start-4 row-end-4">
            <ConfigPanel
              selectedAsset={selectedAsset}
              masterSwitch={masterSwitch}
              gridLocation=""
              handleSetFadeClick={handleSetFadeClick}
              handleToggleSpinDownClick={handleToggleSpinDown}
              handleToggleActiveAssetClick={handleToggleActiveAssetClick}
              handleSetTimeframeSideClick={handleSetTimeframeSideClick}
              handleMasterSwitchClick={handleMasterSwitchClick}
              handleSetJ2F={handleSetJ2F}
              handleSetUpdown={handleSetUpdown}
              handleSetJoeRider={handleSetJoeRider}
              handleSetTacticalStart={handleSetTacticalStart}
              tradingInstrumentActive={tradingInstrument}
              handleToggleTradingInstrumentClick={handleToggleTradingInstrument}
              tradingAuto={tradingAuto}
              handleToggleTradingAutoClick={handleToggleTradingAuto}
              instrumentSyncActive={instrumentSync}
              handleToggleInstrumentSyncClick={handleToggleInstrumentSync}
              handleAbortPostboxClick={handleAbortPostbox}
              handleSetTimeframeMetaAutoresolve={handleSetTimeframeMetaAutoresolve}
              timeframesInfo={timeframesInfo}
              context={selectedStrategy}
              socketStatusLabel="connected"
              socketConnected={timeframesWsConnected}
            />
            <div className={focus ? '' : SOLO_STS_TIMELINE_INLINE_CLASS}>
              <STSTimelineList
                handleSetSTS={handleSetSTS}
                context={selectedStrategy}
                initialData={JSON.parse(timeframesInfo.sts_object)}
              />
            </div>
            {/* Contract Override pins a futures expiry; a stock has nothing to pin. */}
            {selectedAsset.broker === 'ib' && selectedAsset.sectype !== 'STK' &&
              <ConfigPatch
                symbol={selectedAsset.symbol}
                dynamic_patch={JSON.parse(timeframesInfo.dynamic_patch)}
                handleSetPatch={handleSetPatch}
              />
            }
          </div>
          {/* <div className="sm:col-start-1 sm:col-end-1 sm:row-start-2 sm:row-end-2 col-start-1 col-end-1 row-start-6 row-end-6">

          </div> */}
          {!focus && (
            <div className={SOLO_STS_TIMELINE_XL_GRID_LOCATION}>
              <STSTimelineList
                handleSetSTS={handleSetSTS}
                context={selectedStrategy}
                initialData={JSON.parse(timeframesInfo.sts_object)}
              />
            </div>
          )}
          {/* Активный таймфрейм с его историей сигналов */}
          <div className={focus ? SOLO_FOCUS_TOS_PANEL_GRID_LOCATION : TOS_PANEL_SOLO_GRID_LOCATION}>
            <div className="mb-2">
              <InstrumentPlacement
                asset={selectedAsset}
                accounts={accounts}
                onChanged={() => setLibraryRevision((n) => n + 1)}
              />
            </div>
            <TOSPanel
                gridLocation=""
                timeframe={timeframesInfo?.active_timeframe}
                asset={selectedAsset}
                isVirtualAccount={isVirtualAccount}
                synchronizeChangesToLinkedAccounts={synchronizeChangesToLinkedAccounts}
                handleChangeActivePos={handleChangeActivePos}
                handleToggleSide={handleToggleSide}
                // Wave-notification filter only; the TRADING/SCANNER switch stays in the folders.
                tradingInstrumentActive={tradingInstrument}
                scannerWaveFilter={tradingInstrument ? tradingWaveFilter : scannerWaveFilter}
                onCycleScannerWaveFilter={handleCycleScannerWaveFilter}
                onQuantitySet={handleSetTOSQuantity}
                onTOSPatch={handleTOSPatch}
                handleCounterStateChange={handleCounterStateChange}
                handleSetLeverage={handleSetLeverage}
                leverageInitial={timeframesInfo?.leverage}
                username={userProfile?.name}
                onSourcesChange={(sources, tf) => {
                  if (tf) soloSourcesRef.current = { ...soloSourcesRef.current, [tf]: sources };
                }}
                onPatchChange={(patch, tf) => {
                  if (tf) soloPatchRef.current = { ...soloPatchRef.current, [tf]: patch };
                }}
                onReconnect={() => {
                  closeTimeframesSocket();
                  connectTimeframesWs();
                }}
              />
            <SignalHistory
              websocket={timeframes_ws.current}
              selectedAsset={selectedAsset}
              selectedAccount={selectedAccount}
              timeframe={timeframesInfo && timeframesInfo.active_timeframe}
              userProfile={userProfile}
            />
          </div>
          {tvSymbol && (
            <div className="sm:col-span-3 col-span-1 sm:row-start-4 row-start-8 mt-0">
              <SoloStatisticsRow
                selectedAsset={selectedAsset}
                selectedAccount={selectedAccount}
                userProfile={userProfile}
                statistics={statistics}
              />
            </div>
          )}
        </div>
      )}
    </div>
  );
}

export default NewHomePage;
